import React from 'react';
import { connect } from 'react-redux';
import { transparentize } from 'utils/color';
import CircularProgressbar from 'react-circular-progressbar';
import { getColors } from 'store/settings/selectors';
import { Icon } from 'components/common';
import * as courseSelectors from 'store/course/selectors';
import { CIRCLE_DEGREES } from 'constants/common';
import { RootAppState } from 'store/types';
import {
  CourseProgress,
  CourseProgressText,
  CourseProgressCircle
} from './CourseProgressResult.styled';
import CoursePassedBackground from './CoursePassedBackground';
import CourseFailedBackground from './CourseFailedBackground';

type CourseProgressResultProps = {
  masteryScore: number;
  isPassed?: boolean;
  score?: number;
  colors?: { [key: string]: any };
};

export const CourseProgressResult = ({
  isPassed = true,
  score = 0,
  masteryScore = 0,
  colors
}: CourseProgressResultProps) => {
  const progress = (masteryScore / 100) * CIRCLE_DEGREES;
  return (
    <>
      {isPassed ? <CoursePassedBackground /> : <CourseFailedBackground />}
      <CourseProgress isPassed={isPassed}>
        <CourseProgressText isPassed={isPassed}>
          {score}
          <span>%</span>
        </CourseProgressText>
        <CircularProgressbar
          strokeWidth={2}
          percentage={score}
          styles={{
            path: {
              stroke:
                colors && (isPassed ? colors.correctColor : transparentize(colors.textColor, 0.3)),
              strokeLinecap: 'butt',
              transition: 'stroke-dashoffset 0.5s ease'
            },
            trail: {
              stroke: colors && transparentize(colors.textColor, 0.02)
            }
          }}
        />
        <CourseProgressCircle progress={progress} isPassed={isPassed}>
          <li>
            <Icon name="ok" size={6} color="buttonTextColor" />
          </li>
        </CourseProgressCircle>
      </CourseProgress>
    </>
  );
};

function mapStateToProps(state: RootAppState) {
  return {
    colors: getColors(state),
    isPassed: courseSelectors.isPassed(state),
    score: courseSelectors.getScore(state)
  };
}
export default connect(mapStateToProps)(CourseProgressResult);
